import uiReducer from "./ui/reducer";

const reducers: any = {
    ui: uiReducer
}

export default reducers;
